(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aware-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aware-hero-carousel')) {
  customElements.define('aware-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const mobile = window.matchMedia('(max-width: 749px)');
      customElements.whenDefined('slideshow-component').then(() => {
        if (!this.isConnected || signal.aborted) return;
        const slideshow = this.querySelector('slideshow-component');
        if (!slideshow) return;
        const update = () => {
          const paused = slideshow.hasAttribute('paused');
          slideshow.setAttribute('autoplay', '2');
          slideshow.suspend();
          if (!paused) slideshow.resume();
          this.querySelectorAll('picture[data-mobile-alt]').forEach(picture => {
            const image = picture.querySelector('img');
            if (image) image.alt = mobile.matches ? picture.dataset.mobileAlt : picture.dataset.desktopAlt;
          });
        };
        update();
        mobile.addEventListener('change', update, { signal });
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
